// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1Wr-Y","dragIcon":"Choice_dragIcon__3m-m6","left":"Choice_left__2bth6","input":"Choice_input__2A-bs"};